import { render, staticRenderFns } from "./senWordTip.vue?vue&type=template&id=91859312&scoped=true"
import script from "./senWordTip.vue?vue&type=script&lang=js"
export * from "./senWordTip.vue?vue&type=script&lang=js"
import style0 from "./senWordTip.vue?vue&type=style&index=0&id=91859312&prod&lang=scss&scoped=true"
import style1 from "./senWordTip.vue?vue&type=style&index=1&id=91859312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91859312",
  null
  
)

export default component.exports